import { Filter, Headphones } from 'lucide-react';
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api';
import OrderCard from '../components/OrderCard';
import PageMotion from '../components/PageMotion';
import type { Order } from '../types';

const filters = [
  { id: 'active', label: 'Активные' },
  { id: 'completed', label: 'Выполненные' },
  { id: 'all', label: 'Все' }
];

export default function OrdersPage() {
  const [orders, setOrders] = useState<Order[]>([]);
  const [filter, setFilter] = useState('active');
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    const load = () => api<{ orders: Order[] }>('/orders')
      .then((data) => { if (active) setOrders(data.orders); })
      .finally(() => { if (active) setLoading(false); });
    void load();
    const timer = window.setInterval(load, 5000);
    return () => { active = false; window.clearInterval(timer); };
  }, []);
  const visible = useMemo(() => orders.filter((order) => filter === 'all' || filter === 'active' && ['pending', 'processing'].includes(order.status) || filter === 'completed' && order.status === 'completed'), [orders, filter]);
  return (
    <PageMotion>
      <header className="page-header"><div><span className="eyebrow">История кампаний</span><h1>Заказы</h1><p>Вся работа и прогресс в одном месте.</p></div><Link className="primary-button desktop-action" to="/services">Новый заказ</Link></header>
      <div className="filter-bar"><Filter size={17} />{filters.map((item) => <button className={filter === item.id ? 'active' : ''} onClick={() => setFilter(item.id)} key={item.id}>{item.label}<span>{item.id === 'all' ? orders.length : item.id === 'active' ? orders.filter((order) => ['pending', 'processing'].includes(order.status)).length : orders.filter((order) => order.status === 'completed').length}</span></button>)}</div>
      <section className="orders-list">
        {loading ? <div className="loading-state"><span className="spinner" /> Загружаем заказы</div> : visible.length ? visible.map((order) => <OrderCard order={order} key={order.id} />) : <div className="empty-state large"><div><Headphones size={26} /></div><h3>Здесь пока пусто</h3><p>Новые кампании появятся в этом разделе.</p><Link to="/services">Создать заказ</Link></div>}
      </section>
    </PageMotion>
  );
}
